import type { ReactNode } from "react";
import Navigation from "@/components/Navigation";
import HamburgerMenu from "@/components/HamburgerMenu";

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-gray-50">
      <Navigation>
        <HamburgerMenu />
      </Navigation>
      <main className="mx-auto w-full max-w-7xl flex-1 px-4 py-6 sm:px-6 lg:px-8">
        {children}
      </main>
      <footer className="py-3 text-center text-xs text-gray-400">
        EMERSAL v{__APP_VERSION__}
      </footer>
    </div>
  );
}
